module.exports = __webpack_public_path__ + "static/media/iconAlert_warning.916ef02f.svg";